import { render, staticRenderFns } from "./AdminCate2.vue?vue&type=template&id=2010ecd0&scoped=true&"
import script from "./AdminCate2.vue?vue&type=script&lang=js&"
export * from "./AdminCate2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2010ecd0",
  null
  
)

export default component.exports